import _defineProperty from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.fixed";
import _classCallCheck from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import React from "react";
import { Generic } from "../../base";
import { canUseDOM } from "../../utils";
import { NavbarContext } from "./navbar-context";
export var NAVBAR_DEFAULTS = {
  fixedAlignments: ["top", "bottom"]
};
export var NavbarContainer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NavbarContainer, _React$PureComponent);

  function NavbarContainer(props) {
    var _this;

    _classCallCheck(this, NavbarContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NavbarContainer).call(this, props));
    _this.state = {
      active: props.active === true
    };
    return _this;
  }

  _createClass(NavbarContainer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var fixed = this.props.fixed;
      var html = this.document.querySelector("html");

      if (html !== null) {
        html.classList.remove("has-navbar-fixed-".concat(fixed));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames;

      this.manageHtmlAttributes();

      var _a = this.props,
          active = _a.active,
          className = _a.className,
          color = _a.color,
          fixed = _a.fixed,
          innerRef = _a.innerRef,
          managed = _a.managed,
          transparent = _a.transparent,
          rest = tslib_1.__rest(_a, ["active", "className", "color", "fixed", "innerRef", "managed", "transparent"]);

      return React.createElement(NavbarContext.Provider, {
        value: {
          active: this.active,
          setActive: function setActive(value) {
            _this2.active = value;
          }
        }
      }, React.createElement(Generic, Object.assign({
        className: classNames("navbar", (_classNames = {
          "is-transparent": transparent
        }, _defineProperty(_classNames, "is-fixed-".concat(fixed), fixed), _defineProperty(_classNames, "is-".concat(color), color), _classNames), className),
        ref: innerRef,
        role: "navigation"
      }, rest)));
    }
  }, {
    key: "manageHtmlAttributes",
    value: function manageHtmlAttributes() {
      if (canUseDOM()) {
        var html = this.document.querySelector("html");

        if (html !== null) {
          html.classList.remove("has-navbar-fixed-top");
          html.classList.remove("has-navbar-fixed-bottom");

          if (this.props.fixed !== undefined) {
            html.classList.add("has-navbar-fixed-".concat(this.props.fixed));
          }
        }
      }
    }
  }, {
    key: "active",
    get: function get() {
      return this.props.managed === true ? this.props.active === true : this.state.active;
    },
    set: function set(value) {
      if (this.props.managed !== true) {
        this.setState({
          active: value
        });
      }
    }
  }, {
    key: "document",
    get: function get() {
      return this.props.document !== undefined ? this.props.document : document;
    }
  }]);

  return NavbarContainer;
}(React.PureComponent);
NavbarContainer.defaultProps = {
  transparent: false
};
NavbarContainer.displayName = "Navbar.Container";